
export default {
  methods: {
    ToPages (url) {
      this.$router.push(url)
    },
  }
}
